import { render, staticRenderFns } from "./QuestionCaptcha.vue?vue&type=template&id=f85f4a28&scoped=true&"
import script from "./QuestionCaptcha.vue?vue&type=script&lang=js&"
export * from "./QuestionCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCaptcha.vue?vue&type=style&index=0&id=f85f4a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85f4a28",
  null
  
)

export default component.exports